export enum PaymentAdapterTypeEnum {
    Test = 'test',
    CsobTerminal = 'csob_terminal',
    KbTerminal = 'kb_terminal',
    StripeTerminal = 'stripe_terminal',
}
